var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapActions } from "vuex";
import VueDialog from "../../../interface/IVueDialog";
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import CommonService from '../../../api/CommonService';
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.organList = [];
        _this.ediStatus = 0;
        _this.depot = {
            organ_name: '',
            depot_name: '',
            depot_pinyin: '',
            depot_code: '',
            depot_contact: '',
            depot_phone: '',
            depot_address: '',
            sort: '',
            organ_id: '',
            scm_delivery_id: '',
            depot_id: '',
            is_sync: 0
        };
        _this.storeEditInfo = {};
        _this.depotMatchError = "";
        _this.matchTimer = null;
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        this.thirdPartySystemService = ThirdPartySystemService.getInstance();
        if (this.storeEditInfo && JSON.stringify(this.storeEditInfo) != '{}') {
            this.depot = {
                organ_name: this.storeEditInfo.organ_name,
                depot_name: this.storeEditInfo.depot_name,
                depot_pinyin: this.storeEditInfo.depot_pinyin,
                depot_code: this.storeEditInfo.depot_code,
                scm_delivery_id: this.storeEditInfo.scm_delivery_id,
                is_sync: this.storeEditInfo.is_sync,
                depot_contact: this.storeEditInfo.depot_contact,
                depot_phone: this.storeEditInfo.depot_phone,
                depot_address: this.storeEditInfo.depot_address,
                sort: this.storeEditInfo.sort,
                organ_id: this.storeEditInfo.organ_id,
                depot_id: this.storeEditInfo.depot_id,
            };
        }
        else {
            this.depot['organ_id'] = this.organList && this.organList.length && this.organList[0].organ_id;
        }
    };
    AddDialog.prototype.mounted = function () {
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        if (!this.depot.organ_id) {
            this.$message.error("请选择所属机构");
            return;
        }
        ;
        if (this.ediStatus) {
            if (!this.depot.scm_delivery_id) {
                this.$message.error("请输入配送中心门店ID");
                return;
            }
            ;
            if (!this.depot.depot_name) {
                this.$message.error("未匹配到配送中心名称");
                return;
            }
            ;
        }
        else {
            if (!this.depot.depot_name) {
                this.$message.error("请输入配送中心名称");
                return;
            }
            ;
            if (!this.depot.depot_code) {
                this.$message.error("请输入配送中心门店编码");
                return;
            }
            ;
        }
        var params = {
            depot_name: this.depot.depot_name,
            depot_code: this.depot.depot_code,
            scm_delivery_id: this.depot.scm_delivery_id,
            is_sync: this.depot.is_sync,
            depot_contact: this.depot.depot_contact,
            depot_phone: this.depot.depot_phone,
            depot_address: this.depot.depot_address,
            sort: this.depot.sort,
            organ_id: this.depot.organ_id,
        };
        if (this.storeEditInfo && JSON.stringify(this.storeEditInfo) != '{}') {
            var data = {
                depot_id: this.storeEditInfo.depot_id
            };
            Object.assign(data, params);
            this.updateStore(data);
        }
        else {
            this.addStore(params);
        }
    };
    AddDialog.prototype.addStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.addStore(params).then(function (res) {
            if (res.data.success) {
                _this.$closeDialog();
                _this.$emit('addClient:ok', {
                    depot_id: res.data.data,
                    organ_id: _this.depot.organ_id
                });
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog.prototype.updateStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.updateStore(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$closeDialog();
                _this.$emit('addClient:ok');
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog.prototype.getPinyin = function (e) {
        var _this = this;
        var value = e.target.value;
        if (value) {
            this.service.getPinyin({
                name: value
            }).then(function (res) {
                _this.depot.depot_pinyin = res.data.data.pinyin;
            });
        }
        else {
            this.depot.depot_pinyin = '';
        }
    };
    AddDialog.prototype.matchDepotName = function () {
        var _this = this;
        if (this.matchTimer) {
            clearTimeout(this.matchTimer);
        }
        if (!this.depot.scm_delivery_id) {
            this.depotMatchError = "";
            this.depot.depot_name = "";
            this.depot.is_sync = 0;
            return;
        }
        this.matchTimer = setTimeout(function () {
            _this.thirdPartySystemService.getScmDeliveryById({
                scm_delivery_id: _this.depot.scm_delivery_id
            }).then(function (res) {
                if (res.data.success && res.data.data && res.data.data.shopname) {
                    _this.depot.is_sync = 1;
                    _this.depot.depot_name = res.data.data.shopname || "";
                    _this.depot.depot_code = res.data.data.subject || "";
                    _this.getPinyin({ target: { value: _this.depot.depot_name } });
                }
                else {
                    _this.depot.is_sync = 0;
                    _this.depotMatchError = res.data.msg || "配送中心门店ID不存在，请检查";
                    _this.depot.depot_name = "";
                    _this.depot.depot_code = "";
                }
            }).catch(function (err) {
                _this.depot.is_sync = 0;
                _this.depotMatchError = "配送中心门店ID无效，请检查";
                _this.depot.depot_name = "";
            });
        }, 2000);
    };
    AddDialog = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
